var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('AppHeader',{attrs:{"title":"텐텐쿠폰 스탬프 현황 히스토리","is-history":""}}),_c('AppContent',[_c('AsStampHistoryIndex')],1),_c('AppFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }